import { render, staticRenderFns } from "./VUsers.vue?vue&type=template&id=46270bb7&scoped=true"
import script from "./VUsers.vue?vue&type=script&lang=js"
export * from "./VUsers.vue?vue&type=script&lang=js"
import style0 from "./VUsers.vue?vue&type=style&index=0&id=46270bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46270bb7",
  null
  
)

export default component.exports